import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const MapSetBounds = ({ geojson }) => {
  const map = useMap();
  
  useEffect(() => {
    if (!geojson) return;
    const layer = L.geoJSON(geojson);
    const bounds = layer.getBounds();
    map.fitBounds(bounds);
    map.setMaxBounds(bounds.pad(0.2));
    map.setMinZoom(map.getBoundsZoom(bounds) - 1);
  }, [map, geojson]);
  
  return null;
};

export default MapSetBounds;